import Emitter from "es6-event-emitter";

import template from "./../templates/settingsButtonComponent.dust";
import { createDivWithClass } from "./../../../common/utilities/utils";
import Setting from "./../../../common/components/settings/setting";
import i18n from "./../../../common/dictionary";

import { CLICKED_SETTINGS } from "./../../../common/analytics/analyticsevents";

export default class SettingsButtonComponent extends Emitter {
  constructor(appState, regionManager, sessionManager, paywall, options) {
    super();
    this._appState = appState;
    this._regionManager = regionManager;
    this._sessionManager = sessionManager;
    this._paywall = paywall;
    this._options = options;
    this.DOMContainer = document.querySelector(
      ".top-bar-container .top-bar-access"
    );
  }

  render() {
    const context = {
      i18n,
      useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
      displayTopNavButtonlabel: this._options
        ? this._options.displayTopNavButtonlabel
        : false,
    };
    if (this.DOMContainer) {
      Dust.render(template, context, this._renderDone.bind(this));
    }
  }

  //////////////

  _renderDone(err, result) {
    const div = createDivWithClass("settings-button-component");
    if (this._options && this._options.displayTopNavButtonlabel) {
      div.classList.add("labelDisplayed");
    }
    div.innerHTML = result;
    this.DOMContainer.appendChild(div);

    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.DOMContainer.querySelector(
      ".settings-button-component"
    ).addEventListener("click", this._onClickHandler.bind(this));
  }

  _initSettings() {
    this.setting = new Setting(
      this._appState,
      this._regionManager,
      this._sessionManager,
      this._paywall,
      this._options
    );
    this.setting.on("setting:onRegionChanged", () => {
      this.trigger("settingComponent:onRegionChanged");
    });
    this.setting.on("setting:onLoginChanged", () => {
      this.trigger("settingComponent:onLoginChanged");
    });
  }

  _onClickHandler() {
    this._appState.triggerEvent(CLICKED_SETTINGS);
    this._appState.trigger("settingButton:clicked");
    if (!this.setting) {
      this._initSettings();
    }
    this.setting.open();
  }
}



// WEBPACK FOOTER //
// ./src/web/shared/components/settingsButtonComponent.js